import { render } from "./CountrySelect.vue?vue&type=template&id=264a3ffa&scoped=true"
import script from "./CountrySelect.vue?vue&type=script&lang=js"
export * from "./CountrySelect.vue?vue&type=script&lang=js"

import "./CountrySelect.vue?vue&type=style&index=0&id=264a3ffa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264a3ffa"]])

export default __exports__